module.exports = __webpack_public_path__ + "img/buy-a-car.e7f2d682.jpeg";